module.exports = __webpack_public_path__ + "static/Montserrat-Bold-ade91f473255991f410f61857696434b.ttf";